import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-petshop")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-petshop"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-petshop"]!.metaDescription,
    path: "/agente-ia-petshop",
  }),
  component: () => <SegmentRoute slug="agente-ia-petshop" />,
});
